import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)
export const initInfo = () => {
  document
    .querySelectorAll<HTMLHeadingElement>('.js-sustain-info-title')
    .forEach((e) => {
      const handleOpen = (cont: HTMLDivElement, svg: SVGElement) => {
        Object.assign(cont.style, {
          maxHeight: `${cont.scrollHeight}px`
        })

        Object.assign(svg.style, { transform: 'rotate(180deg)' })
        Object.assign(svg.style, { opacity: '0' })
      }

      const handleClose = (cont: HTMLDivElement, svg: SVGElement) => {
        Object.assign(cont.style, { maxHeight: '0px' })

        Object.assign(svg.style, { transform: 'rotate(0deg)' })
        Object.assign(svg.style, { opacity: '1' })
      }

      e.addEventListener('click', () => {
        const content = (e as HTMLHeadingElement)
          .nextElementSibling as HTMLDivElement

        const icon = (e as HTMLHeadingElement).querySelector(
          '.svg-path-plus'
        ) as SVGElement

        const isClosed = content.offsetHeight === 0

        const siblings = (
          (e.parentElement as HTMLLIElement).parentElement as HTMLUListElement
        ).children

        Array.from(siblings).forEach((el) => {
          const elContent = el.lastElementChild as HTMLDivElement

          const elIcon = el.querySelector(
            '.svg-path-plus'
          ) as SVGElement

          const isOpened = elContent.offsetHeight !== 0

          if (isOpened) {
            handleClose(elContent, elIcon)
          }
        })

        if (isClosed) {
          handleOpen(content, icon)
        } else {
          handleClose(content, icon)
        }

        ScrollTrigger.refresh()

      })
    })
}
